"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MomentPreview = void 0;

var _react = _interopRequireDefault(require("react"));

var _hls = _interopRequireDefault(require("hls.js"));

var _reactIntersectionVisible = _interopRequireDefault(require("react-intersection-visible"));

var _helpers = require("../../util/helpers");

var _ = require("../..");

var _atoms = require("../../atoms");

require("./MomentPreview.css");

var _Loading = require("../../molecules/Loading");

var _molecules = require("../../molecules");

var _getTrackingCategory = require("../../util/getTrackingCategory");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var apiEndpoint = process.env.REACT_APP_API;
var tickInterval = null;

var MomentPreview = /*#__PURE__*/function (_React$Component) {
  _inherits(MomentPreview, _React$Component);

  var _super = _createSuper(MomentPreview);

  function MomentPreview(props) {
    var _this;

    _classCallCheck(this, MomentPreview);

    _this = _super.call(this, props);
    _this.track = null;
    _this.videoRef = /*#__PURE__*/_react.default.createRef();
    _this.videoReady = _this.videoReady.bind(_assertThisInitialized(_this));
    _this.onVideoEnded = _this.onVideoEnded.bind(_assertThisInitialized(_this));
    _this.tick = _this.tick.bind(_assertThisInitialized(_this));
    _this.trackingAction = props.trackingAction;
    _this.trackingPlayerType = props.trackingPlayerType;
    _this.state = {
      currentSourceIdx: 0,
      videoShown: false,
      firstPlay: false,
      videoReady: false,
      videoLoading: false,
      loopCount: 0,
      currentProgress: 0,
      isCurrentlyPlaying: false,
      isPaused: false
    };
    return _this;
  }

  _createClass(MomentPreview, [{
    key: "video",
    get: function get() {
      return this.videoRef.current;
    }
  }, {
    key: "duration",
    get: function get() {
      if (!this.video) {
        return 1;
      }

      return this.video.duration;
    }
  }, {
    key: "currentTime",
    get: function get() {
      if (!this.video) {
        return 0;
      }

      return this.video.currentTime;
    },
    set: function set(val) {
      if (!this.video) {
        return;
      }

      this.video.currentTime = val;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      // Get the current moment (at currentSourceIdx) from the sources prop
      var currentMoment = this.props.sources[this.state.currentSourceIdx]; // If the moment exists and the cover image is NOT showing, then load up the video baby!

      if (currentMoment && !this.props.imageCover) {
        this.loadVideo();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.cleanHls();
      this.clearTickInterval();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      // Get the current moment (at currentSourceIdx) from the sources prop
      var prevMoment = this.props.sources[prevState.currentSourceIdx];
      var currentMoment = this.props.sources[this.state.currentSourceIdx];

      if (currentMoment && prevMoment && prevMoment.game_clip_id !== currentMoment.game_clip_id) {
        // console.log('MomentPreview — componentDidUpdate() prevMoment', prevMoment)
        // console.log('MomentPreview — componentDidUpdate() currentMoment', currentMoment)
        this.loadVideo();
      }

      if (!prevState.videoShown && this.state.videoShown) {
        if (this.isReady) {
          !this.state.isPaused && this.play();
        } else {
          this.loadVideo();
        }
      }
    }
  }, {
    key: "clearTickInterval",
    value: function clearTickInterval() {
      if (tickInterval) {
        clearTimeout(tickInterval);
        tickInterval = null;
      }
    }
  }, {
    key: "tick",
    value: function tick() {
      var _this2 = this;

      this.clearTickInterval();
      var vi = this.videoInfo;

      if (this.track) {
        this.track.update(vi);
      }

      var interval = 1000 / 24;

      if (vi.paused === true) {
        interval = 1000 / 8;
      }

      if (this._lastTick !== vi.currentTime) {
        var event = new CustomEvent("tick", {
          detail: vi
        });
        document.dispatchEvent(event);
        this._lastTick = vi.currentTime;
      }

      this.setState({
        currentProgress: vi.currentTime
      });
      tickInterval = setTimeout(function () {
        _this2.tick();
      }, interval);
    }
  }, {
    key: "loadVideo",
    value: function loadVideo() {
      var _this3 = this;

      // console.log('MomentPreview — loadVideo() start')
      // Get the current moment (at currentSourceIdx) from the sources prop
      var moment = this.props.sources[this.state.currentSourceIdx]; // Grab the video player (element)

      var video = this.video;
      video.volume = 0;
      var hlsUrl = (this.props.apiEndpoint ? this.props.apiEndpoint : apiEndpoint) + (0, _helpers.getHlsURL)(moment);
      hlsUrl = hlsUrl.replace("/api/api/", "/api/");
      var nativeHls = video.canPlayType && !!video.canPlayType("application/vnd.apple.mpegURL");

      if (this.loadingVideoUrl === hlsUrl) {
        return;
      } // console.log('MomentPreview — loadVideo()', hlsUrl)
      // If native HLS is supported (Safari? I believe) then go ahead an manage playing through the "canplay" event


      if (nativeHls) {
        video.setAttribute("src", hlsUrl);
        video.load();
        video.addEventListener("canplay", this.videoReady);
      } else if (_hls.default.isSupported()) {
        this.cleanHls();
        var level = this.props.videoLevel === undefined ? 1 : this.props.videoLevel;

        if (level >= 0) {
          this.hls = new _hls.default({
            maxLoadingDelay: 10,
            startLevel: level
          });
          this.hls.currentLevel = level;
        } else {
          this.hls = new _hls.default({
            maxLoadingDelay: 10
          });
        }

        this.hls.config.abrEwmaDefaultEstimate = 4792000 * 1.2;
        this.hls.config.testBandwidth = false;
        this.hls.loadSource(hlsUrl);
        this.hls.attachMedia(video);
        this.hls.on(_hls.default.Events.MANIFEST_PARSED, function () {
          !_this3.state.isPaused && _this3.videoReady();
        });
      }

      this.loadingVideoUrl = hlsUrl;
      this.setState({
        firstPlay: true,
        videoLoading: true
      });
    }
  }, {
    key: "videoReady",
    value: function videoReady() {
      var _this4 = this;

      var level = this.props.videoLevel === undefined ? 1 : this.props.videoLevel;
      if (this.hls && level >= 0) this.hls.startLevel = level;
      this.isReady = true;
      var video = this.video;

      if (video) {
        var autoPlay = this.props.autoPlay || this.props.imageCover && this.state.videoShown;
        video.removeEventListener("canplay", this.videoReady);
        video.playbackRate = this.props.playbackRate ? this.props.playbackRate : 1;
        video.defaultPlaybackRate = this.props.playbackRate ? this.props.playbackRate : 1;
        video.currentTime = 0;
        var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

        if (!isSafari && (0, _helpers.isMobileScreen)() && !autoPlay) {
          this.play();
          setTimeout(function () {
            _this4.pause();
          }, 150);
        }

        if (autoPlay) {
          !this.state.isPaused && this.play();
        }
      }
    }
  }, {
    key: "cleanHls",
    value: function cleanHls() {
      this.loadingVideoUrl = null;

      if (this.hls) {
        this.hls.stopLoad();
        this.hls.destroy();
        this.hls = null;
      }
    }
  }, {
    key: "play",
    value: function () {
      var _play = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(e) {
        var _this5 = this;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (e) e.preventDefault();

                if (this.props.imageCover && !this.state.videoShown) {
                  this.setState({
                    videoShown: true
                  });
                } else {
                  if (this.isReady) {
                    this.setState({
                      loopCount: this.state.loopCount + 1,
                      isPaused: false
                    }, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                      return regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              _context.next = 2;
                              return _this5.doPlay();

                            case 2:
                              if (_this5.props.changeLoopCount) _this5.props.changeLoopCount(_this5.state.loopCount);

                            case 3:
                            case "end":
                              return _context.stop();
                          }
                        }
                      }, _callee);
                    })));
                  } else {
                    this.setState({
                      isPaused: false
                    }, function () {
                      _this5.videoReady();
                    });
                  }
                }

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function play(_x) {
        return _play.apply(this, arguments);
      }

      return play;
    }()
  }, {
    key: "doPlay",
    value: function () {
      var _doPlay = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _this6 = this;

        var currentMoment, isPlaying;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                // Get the current moment (at currentSourceIdx) from the sources prop
                currentMoment = this.props.sources[this.state.currentSourceIdx]; // console.log('MomentPreview — doPlay()', currentMoment)

                if (!this.video) {
                  _context3.next = 17;
                  break;
                }

                this.video.playbackRate = this.props.playbackRate ? this.props.playbackRate : 2;
                isPlaying = !this.video.paused && !this.video.ended && this.video.readyState > this.video.HAVE_CURRENT_DATA;

                if (isPlaying) {
                  _context3.next = 13;
                  break;
                }

                _context3.prev = 5;
                _context3.next = 8;
                return this.video.play();

              case 8:
                _context3.next = 13;
                break;

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3["catch"](5);
                console.log("Err in doPlay() when calling this.video.play()", _context3.t0);

              case 13:
                if (currentMoment && currentMoment.game_clip_id && !this.track) {
                  this.track = new _.VideoTracker(currentMoment.game_clip_id, "mini_preview", this.props.userId, this.props.utmCampaign, (0, _getTrackingCategory.getTrackingCategory)(), this.trackingAction, this.trackingPlayerType, this.trackingPlayerType);
                }

                if (this.track) {
                  this.track.videoStart();
                  this.track.videoPlay();
                }

                this.tick();
                this.setState({
                  isCurrentlyPlaying: true
                }, function () {
                  if (_this6.props.isMomentPlaying) _this6.props.isMomentPlaying(true);
                });

              case 17:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[5, 10]]);
      }));

      function doPlay() {
        return _doPlay.apply(this, arguments);
      }

      return doPlay;
    }()
  }, {
    key: "pause",
    value: function pause(e) {
      var _this7 = this;

      if (e) e.preventDefault();
      if (this.video && !this.video.paused) this.video.pause();
      this.setState({
        isCurrentlyPlaying: false,
        isPaused: true,
        videoLoading: false
      }, function () {
        if (_this7.props.isMomentPlaying) _this7.props.isMomentPlaying(false);
      });
      this.clearTickInterval();
    }
  }, {
    key: "continue",
    value: function _continue(e) {
      var _this8 = this;

      if (e) e.preventDefault();

      if (this.isReady) {
        this.setState({
          isCurrentlyPlaying: true,
          isPaused: false
        }, function () {
          _this8.doPlay();

          if (_this8.props.isMomentPlaying) _this8.props.isMomentPlaying(true);
        });
      }
    }
  }, {
    key: "stop",
    value: function stop(e) {
      // console.log('MomentPreview — stop()')
      this.pause(e);
      if (this.video) this.video.currentTime = 0;
      if (this.track) this.track.videoEnd();
      this.setState({
        loopCount: 0,
        currentProgress: 0,
        isPaused: true
      });
      this.clearTickInterval();
    }
  }, {
    key: "togglePlay",
    value: function togglePlay() {
      if (this.video) {
        if (this.video.paused) {
          this.play();
        } else {
          // console.log('MomentPreview — togglePlay() pause')
          this.pause();
        }
      }
    }
  }, {
    key: "paused",
    get: function get() {
      if (this.video) return this.video.paused;
      return true;
    }
  }, {
    key: "onMouseEnter",
    value: function onMouseEnter(e) {
      if (e) e.preventDefault();

      if (!this.props.noHoverPlay) {
        this.play();
        (0, _.trackEvent)({
          action: "".concat(this.props.utmCampaign ? this.props.utmCampaign : "MomentPreview", ":Hover over video:VideoPlay"),
          element: e === null || e === void 0 ? void 0 : e.currentTarget
        });
      }
    }
  }, {
    key: "onMouseLeave",
    value: function onMouseLeave(e) {
      if (!this.props.noHoverPlay) {
        this.pause(e);
        if (this.props.imageCover) this.setState({
          videoShown: false
        });
      }
    }
  }, {
    key: "onClick",
    value: function onClick(e) {
      if (this.props.onClick) this.props.onClick(e);
    }
  }, {
    key: "onTouchStart",
    value: function onTouchStart(e) {
      var _this9 = this;

      this.touchTimer = setTimeout(function () {
        return _this9.onLongTap();
      }, 600);
    }
  }, {
    key: "onTouchEnd",
    value: function onTouchEnd(e) {
      if (this.touchTimer) {
        clearTimeout(this.touchTimer);
      }
    }
  }, {
    key: "onLongTap",
    value: function onLongTap() {
      if (this.props.onClick) {
        this.props.onClick();
      }
    }
  }, {
    key: "onShow",
    value: function onShow(e) {
      if (this.props.onVisibilityChange) {
        this.props.onVisibilityChange({
          video: this,
          index: this.props.index,
          event: e[0],
          action: "show",
          isCurrentlyPlaying: this.state.isCurrentlyPlaying
        });
      }
    }
  }, {
    key: "onHide",
    value: function onHide(e) {
      if (this.props.onVisibilityChange) {
        this.props.onVisibilityChange({
          video: this,
          index: this.props.index,
          event: e[0],
          action: "hide",
          isCurrentlyPlaying: this.state.isCurrentlyPlaying
        });
      }
    }
  }, {
    key: "getNextSourceIdx",
    value: function getNextSourceIdx() {
      var currentSourceIdx = this.state.currentSourceIdx;
      var nextSourceIdx = currentSourceIdx;
      var sources = this.props.sources;
      var sourcesLength = this.props.sources ? this.props.sources.length : 0;

      if (sources && sourcesLength > 1) {
        if (currentSourceIdx == sourcesLength - 1) {
          nextSourceIdx = 0;
        } else {
          nextSourceIdx += 1;
        }
      } // console.log('MomentPreview — getNextSourceIdx()', nextSourceIdx)


      return nextSourceIdx;
    }
  }, {
    key: "onVideoEnded",
    value: function () {
      var _onVideoEnded = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var _this10 = this;

        var currentMoment, nextSourceIdx;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                // console.log('MomentPreview — onVideoEnded()')
                // Get the current moment (at currentSourceIdx) from the sources prop
                currentMoment = this.props.sources[this.state.currentSourceIdx];

                if (this.track) {
                  this.track.videoEnd();
                }

                if (currentMoment) {
                  this.track = new _.VideoTracker(currentMoment.game_clip_id, null, this.props.userId, this.props.utmCampaign);
                } // Update the currentSourceIdx to the "next" video (which could mean the first, if we're at end of loop)


                nextSourceIdx = this.getNextSourceIdx(); // console.log('MomentPreview — onVideoEnded() nextMomentIdx', nextSourceIdx)

                if (this.state.currentSourceIdx !== nextSourceIdx) {
                  // Set the next index, then play
                  this.setState({
                    currentSourceIdx: nextSourceIdx,
                    videoShown: false,
                    showPlayer: false
                  }, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                    return regeneratorRuntime.wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            _context4.next = 2;
                            return _this10.play();

                          case 2:
                            _this10.setState({
                              videoShown: true,
                              showPlayer: true
                            });

                          case 3:
                          case "end":
                            return _context4.stop();
                        }
                      }
                    }, _callee4);
                  })));
                } else {
                  this.play();
                }

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function onVideoEnded() {
        return _onVideoEnded.apply(this, arguments);
      }

      return onVideoEnded;
    }()
  }, {
    key: "videoInfo",
    get: function get() {
      return {
        paused: this.paused,
        duration: this.duration ? this.duration : 30,
        currentTime: this.currentTime,
        progress: this.currentTime / (this.duration ? this.duration : 30)
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this11 = this;

      // Get the current moment (at currentSourceIdx) from the sources prop
      var currentMoment = this.props.sources[this.state.currentSourceIdx];
      var showCover = !!this.props.imageCover;
      var showPlayer = !showCover || this.state.videoReady;
      var imgUrl = "";
      var currentProgress = this.state.currentProgress;
      var progressBarWidth = this.props.progressBarWidth;
      var showProgressBar = !!this.props.showProgressBar;

      if (showCover) {
        var tm = "";

        if (currentMoment && currentMoment.meta && currentMoment.meta.home_team) {
          tm = currentMoment.meta.home_team.id;
        } else {
          tm = currentMoment.home_team.name;
        }

        var hlsUrl = currentMoment ? "api/teams/".concat(tm, "/games/").concat(tm, "-").concat(currentMoment.game_id, "/").concat(currentMoment.dynamic_hls) : "";
        hlsUrl = hlsUrl.replace("/api/api/", "/api/");
        imgUrl = "https://lapi.traceup.com/exec-".concat(process.env.REACT_APP_TRACE_ENV, "/clip/thumbnail?video=").concat(hlsUrl);
      }

      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactIntersectionVisible.default, {
        onShow: function onShow(e) {
          return _this11.onShow(e);
        },
        onHide: function onHide(e) {
          return _this11.onHide(e);
        },
        options: {
          threshold: [0, 1],
          rootMargin: this.props.rootMargin
        },
        className: "video-intersection-container"
      }, /*#__PURE__*/_react.default.createElement(_atoms.Element, {
        className: "video-cover cursor",
        onMouseEnter: function onMouseEnter(e) {
          _this11.onMouseEnter(e);
        },
        onMouseLeave: function onMouseLeave(e) {
          _this11.onMouseLeave(e);
        },
        onClick: function onClick(e) {
          return _this11.onClick(e);
        }
      }, showCover && /*#__PURE__*/_react.default.createElement("img", {
        alt: "cover",
        src: imgUrl,
        className: !showPlayer ? "visible" : "hidden"
      }), showCover && this.state.videoLoading && /*#__PURE__*/_react.default.createElement(_Loading.Loading, {
        size: "24px"
      }), /*#__PURE__*/_react.default.createElement("video", {
        ref: this.videoRef,
        poster: imgUrl,
        className: "video-lite ".concat(showPlayer ? "visible" : "hidden"),
        playsInline: true,
        onEnded: this.onVideoEnded,
        onPlaying: function onPlaying(e) {
          if (!_this11.state.videoReady) _this11.setState({
            videoReady: true,
            videoLoading: false
          });
        },
        muted: this.props.muted === undefined ? true : !!this.props.muted
      }), showProgressBar && /*#__PURE__*/_react.default.createElement(_molecules.ProgressBar, {
        className: "moment-preview-progress-bar",
        background: _atoms.Color.Black,
        total: this.videoInfo.duration,
        value: currentProgress,
        borderRadius: "0 24px 24px 0",
        opacity: 0.25,
        width: progressBarWidth
      }))));
    }
  }]);

  return MomentPreview;
}(_react.default.Component);

exports.MomentPreview = MomentPreview;
MomentPreview.defaultProps = {
  rootMargin: "0px 0px 0px 0px"
};